<template>
  <div class="contact-modal">
    <div class="modal-header">
      <span>立即开票</span>
      <i class="close" @click="cancel"></i>
    </div>
    <div class="modal-content">
      <FormItem :field="form.payRecordId" :form="form"></FormItem>
      <FormItem :field="form.invoiceType" :form="form"></FormItem>      
      <FormItem :field="form.remarks" :form="form"></FormItem>
      <div class="notice-tip">
        <img src="../../../assets/images/icon-tip.png" alt="" class="icon-notice" />
        <div>邮寄方式:请填写完整邮寄信息，发票将按地址邮寄给您。</div>
      </div>
      <FormItem :field="form.addressee" :form="form"></FormItem>
      <FormItem :field="form.receiptPhone" :form="form"></FormItem>
      <FormItem :field="form.receiptAddress" :form="form"></FormItem>
    </div>
    <div class="modal-footer">
      <button class="cancel" @click="cancel">取消</button>
      <button class="confirm" @click="confirm">保存</button>
    </div>
  </div>
</template>

<script>
import { validateForm } from '@/pages/Activity/components/DynamicForm/service'
import FormItem from "@/components/FormItem";
export default {
  props: {
    form: Object
  },
  components: {
    FormItem
  },
  methods: {
    cancel() {
      this.$emit('cancel');
    },
    confirm() {
      if (!validateForm(this.form)) {
        this.$emit('confirm',this.form);
      }
    }
  }
}
</script>

<style lang="less" scoped>
.contact-modal {
  width: 640px;
  background: #FFFFFF;
  padding: 30px 0;
  box-shadow: 0px 2px 10px 0px rgba(0,0,0,0.0600);

  .modal-header {
    font-size: 20px;
    font-family: PingFang-SC-Bold, PingFang-SC;
    font-weight: bold;
    color: #333333;
    text-align: center;
    margin-bottom: 40px;
    position: relative;

    i {
      cursor: pointer;
      width: 20px;
      height: 20px;
      background: url(../../../assets/images/icon-close.png) no-repeat center center;
      background-size: 100% 100%;
      position: absolute;
      right: 20px;
      top: 0;
    }
  }

  .modal-content {
    margin-bottom: 20px;

    .form-item {
      padding: 0 40px 0 56px;
      margin-bottom: 24px;
      display: flex;
      align-items: center;

      &-label {
        width: 80px;
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #262626;
        margin-right: 20px;
      }

      &-value {
        flex: 1;
        height: 46px;
        background: #F5F5F5;
        position: relative;

        .error-tip {
          position: absolute;
          left: 0;
          top: 100%;
          font-size: 12px;
          color: #FF3B2F;
          line-height: 20px;
          display: none;
        }

        &.error {
          border: 1px solid #FF3B2F;

          .error-tip {
            display: block;
          }
        }

        input {
          width: 80%;
          height: 100%;
          padding: 0 16px;
        }
      }
    }

    hr {
      height: 1px;
      background: #EEEEEE;
      margin: 16px 0 20px 0;
    }

    .notice-tip {
      padding: 0 40px 0 56px;
      display: flex;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #787878;
      line-height: 24px;

      .icon-notice {
        width: 16px;
        height: 16px;
        display: block;
        margin-top: 4px;
        margin-right: 8px;
      }
    }
  }

  .modal-footer {
    display: flex;
    align-items: center;
    justify-content: center;

    button {
      width: 120px;
      height: 40px;
      font-size: 16px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      outline: none;
      border: none;
      cursor: pointer;

      &.cancel {
        margin-right: 20px;
        color: #06AE63;
        background: rgba(6,174,99,0.1000);
      }

      &.confirm {
        background: #06AE63;
        color: #FFFFFF;
      }
    }
  }
}
</style>